import {
    IsArray,
    IsBoolean,
    IsInt,
    IsNotEmpty,
    IsOptional,
    IsString,
} from "class-validator";

export class KanbanTaskDto {
    @IsInt()
    @IsOptional()
    readonly id!: number;

    @IsString()
    @IsNotEmpty()
    readonly description!: string;

    @IsBoolean()
    @IsOptional()
    readonly completed?: boolean;

    @IsInt()
    @IsNotEmpty()
    readonly technical_proposal_activity!: number;

    @IsArray()
    @IsInt({ each: true })
    @IsOptional()
    readonly indicators?: number[];
}

export interface KanbanTaskBody {
    description: string;
    completed?: boolean;
    technical_proposal_activity: number;
    indicators?: number[];
}
